import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';import PropTypes from 'prop-types';
import { hardwareProducts } from '../../../../../modules/customer/profile';
import SimpleTable from '../../../../components/SimpleTable';

const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name', width: 200},
    { title: 'Serial Number', dataIndex: 'serialNumber', key: 'serialNumber', width: 200},
    { title: 'Contract Start', dataIndex: 'contractStartDate', key: 'contractStartDate', width: 150 },
    { title: 'Contract End', dataIndex: 'contractEndDate', key: 'contractEndDate', width: 150 },
    { title: 'Contract Period', dataIndex: 'contractPeriod', key: 'contractPeriod', width: 100},    
    { title: 'Status', dataIndex: 'status', key: 'status', width: 100},
    { title: 'Finance', dataIndex: 'financeOption', key: 'financeOption', width: 50},
    ];

const Products = ({hardwareProducts}) => (
        <SimpleTable
            columns={columns} 
            data={hardwareProducts.productsList}
            isLoading={hardwareProducts.isLoading}
         />
);

const mapStateToProps = createStructuredSelector({
    hardwareProducts: hardwareProducts.selectors.getHardwareProducts
});

export default connect(mapStateToProps)(Products);
